import React from 'react';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import PropTypes from 'prop-types';
import { Column, Row, Button, cls } from '../../packages/components';
import './styles/calendar.scss';
import {applyOutLineFocus} from "../Focus/utils";

const AAFModalMonths = (props = {}) => {
  const classOutLineFocus = applyOutLineFocus();
  const ContentMonths = () => {
        return (
            <Row className={props.device}>
                {props.options.map((m) => {
                    return (
                        <Button
                            id={`content-months-${m.id}`}
                            key={m.id}
                            activate
                            type="button"
                            className={cls('focusable', 'modal-button-months', `${classOutLineFocus}`)}
                            onClick={(e) => props.handleClose(e, props.service(m.id))}
                        >
                            {m.name}
                        </Button>
                    );
                })}
            </Row>
        );
    };
    const p = {
        alwaysEnabled: true,
        buttonsAlign: 'vertical',
        aafNewStyle: true,
        className: 'aaf-modal',
        showLogo: false,
    };
    return (
        <ModalWrapper {...p}>
            <ContentMonths />
        </ModalWrapper>
    );
};

AAFModalMonths.propTypes = {
    title: PropTypes.string,
    className: PropTypes.string,
};

export default withOnClose(AAFModalMonths);



// WEBPACK FOOTER //
// ./src/components/Modal/AAFModalMonths.jsx